export default __webpack_public_path__ + "static/media/nemanja-zunic.fc5d39b7.jpeg";